<template>
  <div v-if="isLoading">
    <div class="text-center text-danger custom-screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <h3 class="text-center mb-4">Filtros</h3>
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label text-right"><strong>Fecha Inicio:</strong></label>
          <div class="col-sm-2 pr-3">
            <date-picker
              class="col-sm-12 px-0"
              v-model="fechaInicio"
              lang="es"
              format="DD/MM/YYYY"
              type="date"
              value-type="date"
            >
            </date-picker>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-5 col-form-label text-right"><strong>Fecha Final:</strong></label>
          <div class="col-sm-2 pr-3">
            <date-picker
              class="col-sm-12 px-0"
              v-model="fechaFinal"
              lang="es"
              format="DD/MM/YYYY"
              type="date"
              value-type="date"
            >
            </date-picker>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-5 col-form-label text-right"><strong>Tipo:</strong> </label>
          <div class="col-sm-3">
            <multiselect
              v-model="tipoSelected"
              :options="tipos"
              :disabled="false"
              label="nombre" track-by="id"
              select-label="" deselect-label="X"
              placeholder="Tipos"
              multiple
              :allow-empty="false"
              :searchable="true">
              <span slot="caret" v-if="!(tipoSelected===null)"></span>
              <span slot="noResult">Sin Resultados</span>
              <span slot="noOptions">Lista Vacia</span>
            </multiselect>
          </div>
        </div>
        <div align="center">
          <button class="btn btn-warning"
           type="button"
           @click="generarInforme">
            Consultar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import moment from 'moment';
import axios from '../../common/axiosERP';
import { util } from '../../../plugins/util';
/* eslint radix: ["error", "as-needed"] */

export default {
  name: 'EfectivoMedico',
  components: {
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      tipoSelected: null,
      tipos: [],

      isLoading: true,
      fechaInicio: new Date(),
      fechaFinal: new Date(),
      listaTipos: [],
    };
  },
  async created() {
    this.isLoading = true;
    await this.cargarDatosIniciales();
    this.isLoading = false;
  },
  methods: {
    async cargarDatosIniciales() {
      try {
        const RESPONSE = await axios.get('clinic/reporte/efectivo_medico/create');
        this.tipos = RESPONSE.data.data.tipos;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    async generarInforme() {
      if (this.fechaInicio === null) {
        util.showNotify('Elija una Fecha de Inicio.', 'warn');
        return;
      }
      if (this.fechaFinal === null) {
        util.showNotify('Elija una Fecha Final.', 'warn');
        return;
      }
      if (this.tipoSelected === null) {
        util.showNotify('Elije un tipo', 'warn');
        return;
      }
      this.listaTipos = this.tipoSelected.map((registro) => parseInt(registro.id));
      const data = {
        fecha_inicio: moment(this.fechaInicio).format('YYYY-MM-DD'),
        fecha_final: moment(this.fechaFinal).format('YYYY-MM-DD'),
        tipos: this.listaTipos,
      };
      try {
        const RESPONSE = await axios.get('clinic/reporte/efectivo_medico/print/excel', {
          params: data,
          responseType: 'blob',
        });
        const BLOB = new Blob([RESPONSE.data], { type: 'data:application/vnd.ms-excel' });
        const DOWNLOAD_URL = URL.createObjectURL(BLOB);
        const A = document.createElement('a');
        A.href = DOWNLOAD_URL;
        A.download = 'Reporte Efectivo Medico.xlsx';
        document.body.appendChild(A);
        A.click();
        document.body.removeChild(A);
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    disableYear(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
    disableMonth(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
  },
};
</script>

<style scoped>
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
